export const WithdrawIcon = () => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 4.69686e-07 18.6274 1.04907e-06 12C1.62846e-06 5.37258 5.37259 4.69686e-07 12 1.04907e-06C18.6274 1.62846e-06 24 5.37259 24 12Z"
        fill="#77A77F"
      />
      <path
        d="M13.9919 7.26953L10.0081 7.26953"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.0006 16.731L12.0006 11.2915"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.0055 12.7471L12 10.7119L7.9945 12.7471"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}
